import { Navigate, Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import PageHome from '../componentes/plantilla/PageHome';
import HomeClientes from "../paginas/clientes/HomeClientes";
import HomeAccesos from '../paginas/empleados/accesos/HomeAccesos';
import HomeActuadores from '../paginas/empleados/actuadores/Estadisticas/HomeActuadores';
import HomeActuador from '../paginas/empleados/actuadores/HomeActuador';
import HomeBuscarEmpleados from '../paginas/empleados/buscar/HomeBuscarEmpleados';
import HomeCargos from "../paginas/empleados/cargos/HomeCargos";
import HomeBuscarClientes from '../paginas/empleados/clientes/buscar/HomeBuscarClientes';
import HomeClientesEmpleados from '../paginas/empleados/clientes/editar/HomeClientes';
import NuevoCliente from '../paginas/empleados/clientes/NuevoCliente';
import EditarEmpleados from "../paginas/empleados/EditarEmpleados";
import HomeEmpleados from '../paginas/empleados/HomeEmpleado';
import HomeInvernaderos from '../paginas/empleados/inicio/HomeInvernadero';
import InicioEmpleados from '../paginas/empleados/inicio/InicioEmpleados';
import NuevoEmpleado from "../paginas/empleados/NuevoEmpleado";
import ActualizarContrasena from "../paginas/login/ActualizarContraseña";
import EnviarPin from "../paginas/login/EnviarPin";
import Login from "../paginas/login/Login";
import ModalRegistroCliente from "../paginas/login/ModalRegistroCliente";
import { AutenticacionRoute } from "./AutenticacionRoute";
import { ClienteLayout } from "./ClienteLayout";
import { AdminLayout } from "./AdminLayout";
import { InvernaderoLayout } from './InvernaderoLayout';
import ComparacionGraficas from '../paginas/empleados/inicio/ComparacionGraficas';

export const routes = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/login" element={<Login />} />
      <Route path="/recuperar-pin" element={<EnviarPin />} />
      <Route path="/actualizar-contrasena" element={<ActualizarContrasena />} />
      <Route path="/registro-cliente" element={<ModalRegistroCliente />} />
      <Route path="app/" element={<AutenticacionRoute />}>
        <Route path="clientes" element={<ClienteLayout />}>
          <Route path="perfil" element={<HomeClientes />} />
        </Route>

        <Route path="admin" element={<AdminLayout />}>
          <Route path="perfil" element={<HomeEmpleados />} />
          <Route path="invernaderos" element={<HomeInvernaderos />} />
          <Route path="resumen" element={<InicioEmpleados />} />
          <Route path="comparar" element={<ComparacionGraficas />} />
          <Route path="controles" element={<HomeActuador />} />
          <Route path="estadisticas" element={<HomeActuadores />} />
          {/*
          <Route element={<InvernaderoLayout />}>
            <Route path="empleados">
              <Route path="resumen" element={<InicioEmpleados />} />
              <Route path="comparar" element={<ComparacionGraficas />} />
              <Route path="editar" element={<EditarEmpleados />} />
              <Route path="buscar" element={<HomeBuscarEmpleados />} />
              <Route path="nuevo" element={<NuevoEmpleado />} />
              <Route path="cargos" element={<HomeCargos />} />
              <Route path="accesos" element={<HomeAccesos />} />
            </Route>

            <Route path="clientes">
              <Route index element={<InicioEmpleados />} />
              <Route path="editar" element={<HomeClientesEmpleados />} />
              <Route path="buscar" element={<HomeBuscarClientes />} />
              <Route path="nuevo" element={<NuevoCliente />} />
            </Route>

            <Route path="actuadores">
              <Route index element={<InicioEmpleados />} />
              <Route path="controles" element={<HomeActuador />} />
              <Route path="estadisticas" element={<HomeActuadores />} />
            </Route>
          </Route>
          */}
        </Route>
        <Route path="home" element={<PageHome />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" />} />
    </Route>
  ),
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);